import WsService from "../WsService";
import ChatUser from "../../domain/Chat/ChatUser";


const ENDPOINT_BASE = "/chat/user";

export default class ChatUserService {
    static retrieve(userId) {
        let endpoint = ENDPOINT_BASE + "/" + userId;
        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new ChatUser(response);
            },
            response => {
                return response;
            }
        );
    }

    static retrieveUsers(userIds){
        let params = {
            'user-ids' : userIds
        }
        return WsService.get(ENDPOINT_BASE, params, 200).then(
            response => {
                let users = [];
                response.forEach(user => {
                    users.push(new ChatUser(user))
                })
                return users;
            },
            error => {
                return error;
            }
        )
    }
}